import React, {useState, memo, useContext} from 'react';
import presentationRu from '../../assets/files/mnj_presentation_ru.pdf';
import presentationEng from '../../assets/files/mnj_presentation_eng.pdf';
import {t} from '../../services/i18nHandler';
import FooterSocialList from './FooterSocialList';
import ModalVideoPlayer from '../Modal/newTemplates/ModalVideoPlayer/ModalVideoPlayer';
import {LanguageContext} from '../../context/LanguageContext';

function FooterBottom() {
  const language = useContext(LanguageContext);

  const onClickDownloadPr = () => {
    if (window.ym) {
      window.ym(56333719, 'reachGoal', language === 'ru' ? 'prrus' : 'preng');
    }
  };

  return (
    <>
      <div className="footer-bottom">
        {/* <div className="footer-item copy-wrap"> */}
        {/*  <span className="copy-text"> */}
        {/*      &copy; 2019 {t('footer.company')}&raquo; */}
        {/*  </span> */}
        {/* </div> */}
        <div className="footer-item mail">
          <a href="mailto:info@mynewjob.pro ">info@mynewjob.pro</a>
        </div>
        <div className="footer-item phone">
          <a href="tel:+78005113912">8 (800) 511-39-12</a>
        </div>
        <div className="footer-item phone">
          <a href="tel:+74951183136">+7 (495) 118-31-36</a>
        </div>
        <div className="footer-item present">
          <div role="button" onClick={onClickDownloadPr} className="present_btn">
            <a href={language === 'ru' ? presentationRu : presentationEng} download>
              <span>{t('footer.downloadPresentation')}</span>
            </a>
          </div>
        </div>
        <div className="footer-item skolkovo">
          <a href="https://navigator.sk.ru/orn/1123797" className="skolkovo-btn" target="_blank">
            <span className="icon icon-skolkovo" />
            {t('footer.skolkovo')}
          </a>
        </div>
        <FooterSocialList />
      </div>
    </>
  );
}

export default memo(FooterBottom);
